// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1XrgP","header":"ClearentDisclaimer_header__iiLfl","inner":"ClearentDisclaimer_inner__nfaFl"};